import React, { useState } from 'react';

const FloatingButtons = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const handleCall = () => {
    window.open('tel:+919842750053', '_self');
  };

  const handleWhatsApp = () => {
    const phoneNumber = '919842750053'; // Your actual WhatsApp number
    const message = 'Hello! I am interested in your industrial machinery and equipment.';
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleEmail = () => {
    const email = 'bharathengineerings@gmail.com'; // Your actual email
    const subject = 'Inquiry about Industrial Machinery';
    const body = 'Hello,\n\nI am interested in your industrial machinery and equipment. Please provide more information.\n\nThank you!';
    const mailtoUrl = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoUrl, '_self');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* WhatsApp Button - Top Left */}
      <div
        className={`absolute transition-all duration-300 ${
          isExpanded 
            ? 'opacity-100 -translate-x-16 -translate-y-20' 
            : 'opacity-0 translate-x-0 translate-y-0 pointer-events-none'
        }`}
      >
        <button
          onClick={handleWhatsApp}
          className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center group"
          title="WhatsApp Us"
        >
          <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488"/>
          </svg>
        </button>
      </div>

      {/* Call Button - Middle Left */}
      <div
        className={`absolute transition-all duration-300 delay-100 ${
          isExpanded 
            ? 'opacity-100 -translate-x-20 -translate-y-8' 
            : 'opacity-0 translate-x-0 translate-y-0 pointer-events-none'
        }`}
      >
        <button
          onClick={handleCall}
          className="w-10 h-10 bg-blue-400 hover:bg-blue-500 rounded-full shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center group"
          title="Call Us"
        >
          <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.95.69l1.5 4.49a1 1 0 01-.5 1.21l-2.26 1.13a11.04 11.04 0 005.52 5.52l1.13-2.26a1 1 0 011.21-.5l4.49 1.5a1 1 0 01.69.95V19a2 2 0 01-2 2h-1C9.72 21 3 14.28 3 6V5z" />
          </svg>
        </button>
      </div>

      {/* Email Button - Bottom Left */}
      <div
        className={`absolute transition-all duration-300 delay-200 ${
          isExpanded 
            ? 'opacity-100 -translate-x-16 translate-y-4' 
            : 'opacity-0 translate-x-0 translate-y-0 pointer-events-none'
        }`}
      >
        <button
          onClick={handleEmail}
          className="w-10 h-10 bg-red-500 hover:bg-red-600 rounded-full shadow-md hover:shadow-lg transition-all duration-300 flex items-center justify-center group"
          title="Email Us"
        >
          <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
          </svg>
        </button>
      </div>

      {/* Main Toggle Button - Center */}
      <button
        onClick={toggleExpanded}
        className="w-16 h-16 bg-[#0a1a3f] hover:bg-[#1e3a8a] rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group"
      >
        {isExpanded ? (
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        ) : (
          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.95.69l1.5 4.49a1 1 0 01-.5 1.21l-2.26 1.13a11.04 11.04 0 005.52 5.52l1.13-2.26a1 1 0 011.21-.5l4.49 1.5a1 1 0 01.69.95V19a2 2 0 01-2 2h-1C9.72 21 3 14.28 3 6V5z" />
          </svg>
        )}
      </button>
    </div>
  );
};

export default FloatingButtons;
